import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import PropTypes from 'prop-types';
import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const httpErrorHeading = (code) => {
  switch (code) {
		case 403:
			return 'Zugriff verweigert';
		case 404:
			return 'Nicht gefunden';
		case 422:
			return 'Ungültige Parameter';
		case 429:
			return 'Zu viele Anfragen';
		case 500:
			return 'Serverfehler';
    default:
      return `Unbekannter ${code} Fehler`;
  }
};

const httpErrorMessage = (code) => {
  switch (code) {
		case 403:
			return 'Sie verfügen nicht über die notwendigen Berechtigungen, um auf diese Ressource zuzugreifen.';
		case 404:
			return 'Das angeforderte Objekt konnte nicht gefunden werden.';
		case 422:
			return 'Ein oder mehrere Parameter wurden vom Server nicht akzeptiert.';
		case 429:
			return 'Das Rate Limit wurde überschritten.';
		case 500:
			return 'Bitte wenden Sie sich an den Administrator.';
    default:
      return `Unbekannter ${code} Fehler`;
    }
};

const ErrorMessage = ({ error }) => {
  const routeError = useRouteError();

  if (routeError) {
    if (isRouteErrorResponse(routeError)) {
      return <Alert severity="error">
        <AlertTitle>{httpErrorHeading(routeError.status)}</AlertTitle>
        <p className="mb-0">{httpErrorMessage(routeError.status)}</p>
        {routeError.statusText ?
          <p className="mt-3 mb-0"><tt>{routeError.statusText}</tt></p>
        : null}
      </Alert>;
    }
		return <Alert severity="error">
			<AlertTitle>Error</AlertTitle>
			<p className="mb-0">{routeError.message || routeError}</p>
		</Alert>;
  }

	if (error.response) {
		return <Alert severity="error">
			<AlertTitle>{httpErrorHeading(error.response.status)}</AlertTitle>
			<p className="mb-0">{httpErrorMessage(error.response.status)}</p>
			{error.response.data && error.response.data.message ?
				<p className="mt-3 mb-0"><tt>{error.response.data.message}</tt></p>
			: null}
		</Alert>;
	}

	if (error.message) {
		return <Alert severity="error">
			<AlertTitle>Error</AlertTitle>
			<p className="mb-0">{error.message}</p>
			{error.stack ?
				<pre className="mt-3 mb-0">{error.stack}</pre>
			: null}
		</Alert>;
	}

	return <div className="error">Error</div>;
};

ErrorMessage.propTypes = {
	error: PropTypes.shape({
		message: PropTypes.string,
		request: PropTypes.shape({}),
		response: PropTypes.shape({
			status: PropTypes.number,
			data: PropTypes.shape({
				message: PropTypes.string,
			}),
		}),
		stack: PropTypes.string,
	}).isRequired,
};

export default ErrorMessage;
